var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationSearching(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.834 0.833008V2.5498C14.3089 2.93313 17.0667 5.6912 17.4502 9.16602H19.167V10.833H17.4502C17.0668 14.308 14.3089 17.0659 10.834 17.4492V19.166H9.16699V17.4492C5.69217 17.0657 2.93411 14.3079 2.55078 10.833H0.833984V9.16602H2.55078C2.93424 5.69129 5.69226 2.93327 9.16699 2.5498V0.833008H10.834ZM10.001 4.16602C6.77598 4.16602 4.16699 6.775 4.16699 10C4.16717 13.2248 6.77609 15.833 10.001 15.833C13.2257 15.8328 15.8338 13.2247 15.834 10C15.834 6.77511 13.2258 4.16619 10.001 4.16602Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationSearching);
export default __webpack_public_path__ + "static/media/location_searching.603c3d4b090e8c18b923d6250c1a2b0f.svg";
export { ForwardRef as ReactComponent };